// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'document-download-solid';

export const Component = () => (
  <path d='M15.746 6.37 15.698.287l6.466 6.466.096.096h-6.034c-.335 0-.48-.144-.48-.479Zm.479 1.485h6.37v15.182c0 .431-.144.766-.432 1.054a1.408 1.408 0 0 1-1.054.43H3.485a1.41 1.41 0 0 1-1.054-.43A1.408 1.408 0 0 1 2 23.037V1.485c0-.431.144-.766.431-1.054A1.408 1.408 0 0 1 3.485 0H14.74v6.37c0 .43.144.766.431 1.053.288.288.623.432 1.054.432Zm-.623 7.997a.542.542 0 0 0-.382-.143.434.434 0 0 0-.336.143l-2.107 2.107v-7.662c0-.335-.143-.479-.479-.479-.335 0-.478.144-.478.479v7.662l-2.107-2.107a.434.434 0 0 0-.336-.143c-.335 0-.526.143-.526.479 0 .047.047.143.144.335l2.97 2.97c.19.095.287.143.334.143.048 0 .144-.048.335-.144l2.97-2.97a.434.434 0 0 0 .144-.334c0-.144-.048-.288-.144-.336h-.002Z' />
);

export const viewBox = '0 0 25 25';
